// ACC-533: config table for the Tickets section of the notification settings
// page. The ticketing backend stores keys as `${channel}${Type}` (e.g.
// inAppAssigned). This is the single source of truth for the rows + key derivation.

export type TicketNotifType = 'assigned' | 'mentioned' | 'customerReplied' | 'watching' | 'slaBreached';
export type TicketNotifChannel = 'inApp' | 'email';

export interface TicketNotifRow {
	type: TicketNotifType;
	labelKey: string; // react-intl message id
}

export const TICKET_NOTIF_ROWS: readonly TicketNotifRow[] = [
	{type: 'assigned', labelKey: 'profile.notifications.ticket_assigned'},
	{type: 'mentioned', labelKey: 'profile.notifications.ticket_mentioned'},
	{type: 'customerReplied', labelKey: 'profile.notifications.ticket_customer_replied'},
	{type: 'watching', labelKey: 'profile.notifications.ticket_watching'},
	{type: 'slaBreached', labelKey: 'profile.notifications.ticket_sla_breached'},
];

const TYPE_SUFFIX: Record<TicketNotifType, string> = {
	assigned: 'Assigned',
	mentioned: 'Mentioned',
	customerReplied: 'CustomerReplied',
	watching: 'Watching',
	slaBreached: 'SlaBreached',
};

/** Backend/GraphQL pref key for a (type, channel) cell, e.g. inAppAssigned / emailWatching. */
export function ticketPrefKey(type: TicketNotifType, channel: TicketNotifChannel): string {
	return `${channel}${TYPE_SUFFIX[type]}`;
}
